import { render, staticRenderFns } from "./select-blank.vue?vue&type=template&id=70a95634&scoped=true&"
import script from "./select-blank.vue?vue&type=script&lang=ts&"
export * from "./select-blank.vue?vue&type=script&lang=ts&"
import style0 from "./select-blank.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./select-blank.vue?vue&type=style&index=1&id=70a95634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a95634",
  null
  
)

export default component.exports